var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 24",
    role: "img",
    "aria-label": "Google",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 19,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4285F4"
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#EA4335"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FBBC05"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#4285F4"
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#34A853"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#EA4335"
  }, "e"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7ca0f5131cc3a87d8d1690d2e90fac7f.svg";
export { ForwardRef as ReactComponent };